/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import {
  Button,
  Modal,
  notification,
  TableProps,
  Upload,
  UploadFile,
  UploadProps,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import TableComponent from '@/components/table';
import { getExcelData } from '@/helpers/excelHelper';
import { useMutation } from '@tanstack/react-query';

import { formatNumber } from '@/utils/dataUtils';
import { IMediaUpload } from '@/interfaces/media';
import { uploadMedia } from '@/adapters/media';
import {
  IStockMatchingReportReq,
  IStockMatchingReportRes,
} from '@/interfaces/report';
import { isEmpty, isUndefined } from 'lodash';
import { importStockMatching } from '@/adapters/report';
import _ from 'lodash';

interface IProps {
  open: boolean;
  handleOk: () => void;
  handleCancel: () => void;
}

const ImportStockMatchingModal = ({ open, handleOk, handleCancel }: IProps) => {
  const [items, setItems] = useState<Partial<IStockMatchingReportRes>[]>([]);
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const columns: TableProps<Partial<IStockMatchingReportRes>>['columns'] = [
    {
      title: 'ITEM NO',
      dataIndex: 'productCode',
      key: 'productCode',
      className: 'font-bold',
      width: 130,
      align: 'center',
    },
    {
      title: 'ITEM DESC',
      dataIndex: 'productName',
      key: 'productName',
      className: 'font-bold',
    },
    {
      title: 'LOT NO',
      dataIndex: 'keminLotNumber',
      key: 'keminLotNumber',
      width: 160,
      align: 'center',
      className: 'font-bold',
    },
    {
      title: 'QUANTITY',
      dataIndex: 'keminQuantity',
      key: 'keminQuantity',
      className: 'font-bold',
      width: 130,
      align: 'right',
      render: _ => formatNumber(_, 2),
    },
  ];

  const props: UploadProps = {
    onRemove: () => {
      setFileList([]);
      setItems([]);
    },
    beforeUpload: async file => {
      setFileList([file]);
      let excelData: any[] = (await getExcelData(file)) as any[];
      excelData = excelData
        .slice(1)
        .filter(c => !isEmpty(c[0]) || !isUndefined(c[0]))
        .map((c: any) => {
          console.log(c);
          const match: IStockMatchingReportRes = {
            productCode: c[0].toString(),
            productName: c[1].toString(),
            keminQuantity: c[7],
            keminLotNumber: c[5].toString(),
          } as IStockMatchingReportRes;
          return match;
        });
      const groupedData = _(excelData)
        .groupBy('keminLotNumber')
        .map((items, key) => ({
          keminLotNumber: key,
          keminQuantity: _.sumBy(items, 'keminQuantity'),
          productCode: items[0].productCode, // Get the first invoice number
          productName: items[0].productName,
        }))
        .value();
      setItems(groupedData);
    },
    fileList,
    showUploadList: true,
    accept: '.xlsx',
  };

  const upLoadmutations = useMutation({
    mutationFn: async (data: Partial<IMediaUpload>) => await uploadMedia(data),
    mutationKey: ['upload-media'],
    onSuccess: data => {
      console.log(data);
    },
    onError: error => {
      console.log(error);
    },
  });

  const mutations = useMutation({
    mutationFn: async (data: IStockMatchingReportReq) =>
      await importStockMatching(data),
    mutationKey: ['import-stock-matching'],
    onSuccess: data => {
      if (data.status === 200) {
        setFileList([]);
        // setBu(0);
        notification.success({
          message: 'นำเข้า Stock Matching สำเร็จ',
        });
        const file: Partial<IMediaUpload> = {
          file: fileList.length ? (fileList[0] as any) : null,
          modelId: 1,
          modelType: 'stock',
        };
        upLoadmutations.mutateAsync(file);
        handleOk();
      }
    },
    onError: error => {
      console.log('error', error);
    },
  });

  const onImportData = () => {
    const dataImport: IStockMatchingReportReq = {
      data: items,
    };
    mutations.mutateAsync(dataImport);
  };

  const isDisabled = !!items?.length;

  return (
    <Modal
      title="นำเข้า Stock"
      open={open}
      width={'1200px'}
      onOk={() => handleOk}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      footer={[
        <Button key="back" onClick={handleCancel}>
          ปิด
        </Button>,
        <Button
          key="submit"
          type="primary"
          form="unit"
          className=" !hover:"
          disabled={!isDisabled}
          onClick={() => onImportData()}
          loading={mutations.isPending}
        >
          นำเข้า
        </Button>,
      ]}
      afterClose={() => {
        setFileList([]);
        setItems([]);
      }}
    >
      <div className="flex flex-col gap-2 w-full">
        <div className="flex flex-row gap-2 justify-between items-center">
          <Upload {...props}>
            {fileList.length === 0 && (
              <Button icon={<UploadOutlined />}>เลือกไฟล์</Button>
            )}
          </Upload>
        </div>
        <TableComponent<Partial<IStockMatchingReportRes>>
          columns={columns}
          criteria={{}}
          data={{
            data: items,
            totalRecords: items.length,
          }}
          loading={false}
          onTableChange={undefined}
          scroll={false}
          rowKey="keminOrderNo"
          defaultPagination={true}
        />
      </div>
    </Modal>
  );
};

export default ImportStockMatchingModal;
